import { makeStyles } from "@material-ui/styles";
import { COLORS } from '../../../../../styles/constants/colors';

export const useStyles = makeStyles(() => ({
  bottomContainer: {
    padding: "20px 30px",
    display: "flex",
    flexDirection: "row",
    boxShadow: "0px 4px 24px rgba(85, 100, 119, 0.11)",
    backgroundColor: "linear-gradient(178deg, #F8F9FA 1.68%, #FFFFFF 98.32%)",
  },

  illustration: {
    width: "363px",
    height: "274px",
  },

  rightContainer: {
    alignContent: "center",
  },

  utilityBillsContainer: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
  },

  utilityOwnerPay: {
    padding: "0px",
    margin: "0px",
    justifyContent: "start",
    alignContent: "center",
    width: "fit-content",
    marginLeft: "10px",
  },

  finalBills: {
    maxHeight: "30px",
    width: "240px",
    minWidth: "240px",

    backgroundColor: "#fff",
    color: "#4B617C",
    justifyContent: "start",
    alignContent: "center",
    padding: "5px 20px",
    margin: "5px",
    marginLeft: "-15px",
    boxShadow: "0px 4px 24px rgba(85, 100, 119, 0.2)",
    borderRadius: "2px",
    '@media print': {
      boxShadow: 'none',
    }
  },

  arrow: {
    alignContent: "center",
    height: "30px",
    width: "23px",
    minWidth: "23px",
    justifyContent: "center",
    margin: "5px",
    marginTop: "5px",
  },

  billBarGreen: {
    height: "30px",
    marginTop: "5px",
    borderRadius: "2px 0px 0px 2px",
    margin: "0 2px",
    minWidth: "110px",
    color: "#fff",
    padding: "0 10px",
    alignContent: "center",
    background: "linear-gradient(116.22deg, #009299 16.5%, #00B488 83.5%)",
    '@media print': {
      border: `2px solid ${COLORS.PRIMARY}`,
    }
  },

  blackBillBar: {
    backgroundColor: `${COLORS.BLACK}`,
    height: "30px",
    marginTop: "5px",
    marginRight: "0px",
    padding: "0 5px",
    borderTopRightRadius: "2px",
    borderBottomRightRadius: "2px",
    '@media print': {
      border: '2px solid black',
    }
  },
  blackBillTotal: {
    height: "30px",
    alignContent: "center",
    marginTop: "5px",
  },

  bottomBarsContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    marginTop: "20px",
  },

  finalBillsLastBar: {
    minHeight: "43px",
    width: "240px",
    minWidth: "240px",
    padding: "5px 16px",
    backgroundColor: "white",
    justifyContent: "start",
    alignContent: "center",
    margin: "5px",
    marginLeft: "-15px",
    boxShadow: "0px 4px 24px rgba(85, 100, 119, 0.2)",
    borderRadius: "2px",
    '& h6': {
      color: `${COLORS.BLACK}`,
    },
    '@media print': {
      boxShadow: 'none',
    }
  },

  arrowLastBar: {
    alignSelf: "center",
    width: "35px",
    minWidth: "35px",
    padding: "0px 10px",
    justifyContent: "center",
    alignContent: "center",
  },
  billBarGreenLastBar: {
    height: "43px",
    marginTop: "5px",
    borderRadius: "2px 0px 0px 2px",
    color: "#fff",
    paddingLeft: "20px",
    alignContent: "center",
    background: "linear-gradient(116.22deg, #009299 16.5%, #00B488 83.5%)",
    '& h6': {
      fontSize: "18px",
    },
    '@media print': {
      border: `2px solid ${COLORS.PRIMARY}`,
    }
  },
  blackBillBarLastBar: {
    backgroundColor: `${COLORS.BLACK}`,
    height: "43px",
    marginTop: "5px",
    paddingLeft: "16px",
    alignContent: "center",
    marginLeft: "2px",
    borderTopRightRadius: "2px",
    borderBottomRightRadius: "2px",
    '@media print': {
      border: '2px solid black',
    }
  },
  billBarText: {
    fontSize: "13px",
    lineHeight: "19.5px",
    color: "white",
  },
  billBarBlackText: {
    fontSize: "1em",
    color: "white",
  }
}));
